import { createNomogramWidget } from './shared/nomogram.js';
import fields from './shared/fields.js';
import colors from './shared/colors.js';

const lutsWidgetApp = createNomogramWidget({
    dataApi: '/umbraco/api/luts/calculate',
    errorMessage: 'Failed to calculate LUTS',
    chartColors: [
        colors.green,
        colors.yellow,
        colors.red,
    ],
    fields: [
        fields.CT,
        fields.ProstateSize,
        fields.PSA,
        fields.IPSS,
        fields.Age,
        fields.FP,
        fields.IPSSStorageDomain,
        fields.IPSSVoidingDomain,
    ],
    payload: vm => ({
        CT: vm.CT,
        ProstateSize: vm.ProstateSize,
        PSA: vm.PSA,
        IPSS: vm.IPSS,
        Age: vm.Age,
        FP: vm.FP,
        IPSSStorageDomain: vm.IPSSStorageDomain,
        IPSSVoidingDomain: vm.IPSSVoidingDomain,
    }),
});

export default lutsWidgetApp;
